import { render, staticRenderFns } from "./ListStudent.vue?vue&type=template&id=0b0d86e0&"
import script from "./ListStudent.vue?vue&type=script&lang=js&"
export * from "./ListStudent.vue?vue&type=script&lang=js&"
import style0 from "./ListStudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
